/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AutomationTemplateQueryProvider extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AutomationTemplateQueryProvider");
    }

    getFixupPrototypeFunction() { return AutomationTemplateQueryProvider.fixupPrototype; }

    static newInstance(model: Partial<AutomationTemplateQueryProvider>): AutomationTemplateQueryProvider {
        let obj = Object.assign(new AutomationTemplateQueryProvider(), model);
        AutomationTemplateQueryProvider.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AutomationTemplateQueryProvider>): AutomationTemplateQueryProvider {
        if (!model) return null;
        return AutomationTemplateQueryProvider.newInstance(<AutomationTemplateQueryProvider> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AutomationTemplateQueryProvider) {
        if (!obj) return;

        models.AutomationTemplateQueryProvider.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AutomationTemplateQueryProvider): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AutomationTemplateQueryProvider.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Template providers to include
     */
    provider: Array<models.ProviderName>;

}
